import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Brands, CustomerLookup } from 'shared/types';

export function useCustomerSearch(query: string, brand: Brands) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isFetching, isLoading } = useQuery<Record<keyof CustomerLookup, string>[], Error>(
    ['customer', query],
    () =>
      quoteService.autoCompleteSearch<CustomerLookup>({
        query,
        brand,
        searchColumn: 'customernumbername',
        table: 'customers',
      }),
    {
      initialData: [],
      enabled: Boolean(query),
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
    }
  );

  return { data, isFetching, isLoading } as const;
}
